import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { PatternFill } from "../shared/PatternFill.mjs";
import { getGeoShapePath } from "./getGeoShapePath.mjs";
function GeoShapeBody({
  shape,
  shouldScale,
  forceSolid,
  strokeColor,
  strokeWidth: unscaledStrokeWidth,
  fillColor,
  patternFillFallbackColor,
  customGeoTypes
}) {
  const scaleToUse = shouldScale ? shape.props.scale : 1;
  const strokeWidth = unscaledStrokeWidth * scaleToUse;
  const { dash, fill } = shape.props;
  const path = getGeoShapePath(shape, unscaledStrokeWidth, customGeoTypes);
  const fillPath = dash === "draw" && !forceSolid ? path.toDrawD({ strokeWidth, randomSeed: shape.id, passes: 1, offset: 0, onlyFilled: true }) : path.toD({ onlyFilled: true });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    fill === "none" ? null : fill === "pattern" ? /* @__PURE__ */ jsx(
      PatternFill,
      {
        d: fillPath,
        fillColor,
        patternFillFallbackColor,
        scale: scaleToUse
      }
    ) : /* @__PURE__ */ jsx("path", { fill: fillColor, d: fillPath }),
    path.toSvg({
      style: dash,
      strokeWidth,
      forceSolid,
      randomSeed: shape.id,
      props: { fill: "none", stroke: strokeColor }
    })
  ] });
}
export {
  GeoShapeBody
};
//# sourceMappingURL=GeoShapeBody.mjs.map
